import { getDateRangeArray, getDateFromUnix, getUnixTime, trimDecimals, averageNumberArrayFast } from '@einhaus/meteoric-helpers';
export const calculatePositionsPerDay = (tradeSummaries) => {
    const lowestTimestamp = Math.min(...tradeSummaries.map((t) => t.start));
    const highestTimestamp = Math.max(...tradeSummaries.map((t) => t.end));
    const dateRange = getDateRangeArray(getDateFromUnix(lowestTimestamp), getDateFromUnix(highestTimestamp));
    const positionsByDay = {};
    // Iterate over every day in the range so that we can get the positions for each day and then average it
    for (const date of dateRange) {
        const timestamp = getUnixTime(date);
        const trades = tradeSummaries.filter((t) => timestamp >= t.start && timestamp <= t.end);
        const positions = trades.length;
        if (!positions)
            continue;
        positionsByDay[date] = positions;
    }
    return trimDecimals(averageNumberArrayFast(Object.values(positionsByDay)));
};
//# sourceMappingURL=calculatePositionsPerDay.js.map